import { UpdateProcessRequestDto } from '@/api/generated';
import {
  CustomerTypeOptionsTranslation,
  customerTypeOptionsTranslation,
  processStatusOptionsTranslation,
  ProcessStatusTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';

export type ProcessesUpdateTranslation = {
  button: {
    cancel: string;
    save: string;
  };
  dialog: {
    addContact: {
      button: {
        close: string;
        createContact: string;
      };
      title: string;
    };
    addCustomer: {
      button: {
        close: string;
        createCustomer: string;
      };
      menu: CustomerTypeOptionsTranslation;
      title: string;
    };
  };
  form: Record<keyof UpdateProcessRequestDto, string> & {
    owner: string;
    statusOptions: ProcessStatusTranslation;
  };
  title: string;
};

export const processUpdateTranslation: ProcessesUpdateTranslation = {
  button: {
    cancel: 'Anuluj',
    save: 'Zapisz',
  },
  dialog: {
    addContact: {
      button: {
        close: 'Zamknij',
        createContact: 'Utwórz kontakt',
      },
      title: 'Dodaj kontakt do procesu',
    },
    addCustomer: {
      button: {
        close: 'Zamknij',
        createCustomer: 'Utwórz klienta',
      },
      menu: customerTypeOptionsTranslation,
      title: 'Dodaj klienta do procesu',
    },
  },
  form: {
    description: 'Opis',
    name: 'Nazwa',
    owner: 'Właściciel',
    status: 'Status',
    statusOptions: processStatusOptionsTranslation,
  },
  title: 'Edycja procesu',
};
